import React from 'react';

import { cn } from '@/services/utils';

const TableCell = React.forwardRef<
    HTMLTableCellElement,
    React.TdHTMLAttributes<HTMLTableCellElement> & {
        pinned?: boolean,
        leftPinned?: boolean,
        pinnedPosition?: number,
        // LAX-10037: explicit sticky offsets so multiple user-pinned
        // columns can stack correctly instead of all snapping to left:0
        // or right:0. When `leftPinned` (right-pinned columns still fall
        // back to the legacy `pinnedPosition` for callers that haven't
        // migrated yet).
        leftOffset?: number,
        rightOffset?: number,
        hasPadding?: boolean,
    }
>(({ className, pinned, leftPinned, pinnedPosition = 0, leftOffset, rightOffset, hasPadding = false, style, ...props }, ref) => {
    const stickyStyle: React.CSSProperties = {};
    if (leftPinned) {
        stickyStyle.left = leftOffset ?? 0;
    }
    if (pinned) {
        stickyStyle.right = rightOffset ?? pinnedPosition ?? 0;
    }
    return (
        <td
            ref={ref}
            tabIndex={-1}
            style={{ ...stickyStyle, ...(style ?? {}) }}
            className={cn(
                'scoped-table-cell tw-h-9 tw-align-middle [&:has([role=checkbox])]:tw-pr-0 tw-py-0.5 tw-m-0',
                'focus:tw-outline focus:tw-outline-2 focus:tw-outline-offset-[-2px] focus:tw-outline-primary',
                hasPadding ? 'tw-px-2' : '',
                pinned ? 'pinned tw-bg-white' : '',
                leftPinned ? 'left-pinned tw-bg-white' : '',
                className,
            )}
            {...props}
        />
    );
});

TableCell.displayName = 'TableCell';

export { TableCell };
